var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { localized, msg } from '@lit/localize';
import { CommonActions } from '../../../localization/helpers.js';
import './TextNodeInput';
import '../../button/SimpleButton';
let KeyValueNodeInput = class KeyValueNodeInput extends LitElement {
    constructor() {
        super(...arguments);
        this.keyValuePairs = [];
    }
    // Observateur pour la propriété `input`
    updated(changedProperties) {
        if (changedProperties.has('input') && this.input?.value) {
            this.syncKeyValuePairs();
        }
    }
    syncKeyValuePairs() {
        // Convertit `input.value` en tableau de paires clé/valeur
        const value = this.input?.value || {};
        this.keyValuePairs = Object.entries(value).map(([key, value]) => ({
            key,
            value: value,
        }));
        this.requestUpdate();
    }
    onKeyChange(index, event) {
        const newKey = event.detail.input.value;
        this.keyValuePairs = this.keyValuePairs.map((pair, i) => i === index ? { ...pair, key: newKey } : pair);
        this.requestUpdate();
        this.onInputChange();
    }
    onValueChange(index, event) {
        const newValue = event.detail.input.value;
        this.keyValuePairs = this.keyValuePairs.map((pair, i) => i === index ? { ...pair, value: newValue } : pair);
        this.requestUpdate();
        this.onInputChange();
    }
    addKeyValuePair() {
        this.keyValuePairs = [...this.keyValuePairs, { key: '', value: '' }];
        this.requestUpdate();
    }
    removeKeyValuePair(index) {
        this.keyValuePairs = this.keyValuePairs.filter((_, i) => i !== index);
        this.requestUpdate();
    }
    onInputChange() {
        const keyValueObject = this.keyValuePairs.reduce((acc, pair) => {
            if (pair.key) {
                acc[pair.key] = pair.value;
            }
            return acc;
        }, {});
        this.input.value = keyValueObject;
        this.dispatchEvent(new CustomEvent('node-input-change', {
            detail: {
                key: this.key,
                input: this.input,
            },
            bubbles: true,
            composed: true
        }));
    }
    render() {
        return html `
            <div class="key-value-container">
                ${this.keyValuePairs.map((pair, index) => html `
                    <div class="key-value-row">
                        <text-node-input
                            .input=${{ value: pair.key, placeholder: msg('Key', { id: 'nodeInput.placeholder.key', desc: 'Key placeholder for key/value input' }) }}
                            @node-input-change=${(e) => this.onKeyChange(index, e)}
                        ></text-node-input>
                        <text-node-input
                            .input=${{ value: pair.value, placeholder: msg('Value', { id: 'nodeInput.placeholder.value', desc: 'Value placeholder for list/key-value input' }) }}
                            @node-input-change=${(e) => this.onValueChange(index, e)}
                        ></text-node-input>
                        <simple-button
                            label="${CommonActions.remove()}"
                            variant="danger"
                            size="small"
                            @button-click=${() => this.removeKeyValuePair(index)}
                        ></simple-button>
                    </div>
                `)}
                <simple-button
                    label="${msg('Add Key/Value', { id: 'nodeInput.action.addKeyValue', desc: 'Add key/value pair button' })}"
                    variant="success"
                    size="small"
                    @button-click=${this.addKeyValuePair}
                ></simple-button>
            </div>
        `;
    }
};
KeyValueNodeInput.styles = css `
      .key-value-container {
        display: flex;
        flex-direction: column;
        gap: 9px; /* Réduction de 25% */
        padding: 12px; /* Réduction de 25% */
        border: 1px solid #ddd;
        border-radius: 6px; /* Réduction de 25% */
        background-color: #f9f9f9;
      }

      .key-value-row {
        display: flex;
        align-items: center;
        gap: 9px; /* Réduction de 25% */
      }

      text-node-input {
        flex: 1;
      }
    `;
__decorate([
    property({ type: String })
], KeyValueNodeInput.prototype, "key", void 0);
__decorate([
    property({ type: Object })
], KeyValueNodeInput.prototype, "input", void 0);
__decorate([
    state()
], KeyValueNodeInput.prototype, "keyValuePairs", void 0);
KeyValueNodeInput = __decorate([
    localized(),
    customElement('key-value-node-input')
], KeyValueNodeInput);
export { KeyValueNodeInput };
//# sourceMappingURL=KeyValueNodeInput.js.map